"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_AXEPTA_PAYMENT_REQUEST = void 0;
const client_1 = require("@apollo/client");
exports.GET_AXEPTA_PAYMENT_REQUEST = client_1.gql `
  query getAxeptaPaymentRequest(
    $amount: String!
    $userRedirectUrl: String!
  ) {
    axeptaV2(
      amount: $amount
      userRedirectUrl: $userRedirectUrl
    ) {
      _links {
        redirect {
          href
          type
        }
      }
    }
  }
`;
